var _circle, _circle2, _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarbleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8941,
    cy: 42.106,
    r: 28.9667,
    fill: "#B9BEC6",
    stroke: "#505862",
    strokeWidth: 1.72149
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.16479,
    y: 48.1548,
    width: 11.6615,
    height: 4.99776,
    rx: 2.49888,
    fill: "#B9BEC6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16479,
    y: 31.4922,
    width: 11.6615,
    height: 4.99776,
    rx: 2.49888,
    fill: "#B9BEC6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39.825,
    width: 13.3274,
    height: 4.99776,
    rx: 2.49888,
    fill: "#B9BEC6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3099 40.8573C76.7419 41.2585 76.7348 41.9443 76.2948 42.3366L59.1262 57.6387C58.3323 58.3463 57.129 57.4898 57.5376 56.5079L63.0421 43.2821C63.5404 42.0846 63.554 40.7404 63.0799 39.5331L57.906 26.359C57.5172 25.3689 58.7379 24.5369 59.5173 25.2607L76.3099 40.8573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarbleGray);
export default __webpack_public_path__ + "static/media/MarbleGray.102ad6619c8d7eba877021887493316b.svg";
export { ForwardRef as ReactComponent };